import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  constructor(
    private readonly api: ApiService,
    private readonly fileService: FileService,
  ) {}

  public async downloadDocument(filename: string): Promise<void> {
    const uri: string = environment.api.links + '/' + filename;
    const data: Blob = await this.api.getFile(uri);
    return this.fileService.saveAs(data, filename);
  }
}
